import React from "react";
import { useTranslation } from "@helpers/translate";

import "./index.sass";

const getArrowStyle = (arrow) => {
  if (!arrow) return {};

  const arrowStyle = {};

  const setArrowVariable = (name, value) => {
    if (value === undefined || value === null) return;

    arrowStyle[`--futures-guide-arrow-${name}`] =
      typeof value === "number" ? `${value}px` : value;
  };

  setArrowVariable("left", arrow.left);
  setArrowVariable("right", arrow.right);
  setArrowVariable("top", arrow.top);
  setArrowVariable("bottom", arrow.bottom);

  return arrowStyle;
};

const FuturesGuideTooltip = ({
  title,
  description,
  currentStep,
  totalSteps,
  placement,
  isFirstStep,
  isLastStep,
  style,
  arrow,
  onBack,
  onNext,
}) => {
  const { __ } = useTranslation();

  const arrowSide = arrow?.side || placement;

  return (
    <div
      className={`futures-guide-tooltip futures-guide-tooltip--${placement} futures-guide-tooltip--arrow-${arrowSide}`}
      style={{
        ...style,
        ...getArrowStyle(arrow),
      }}
    >
      <div className="futures-guide-tooltip__head">
        <h3 className="futures-guide-tooltip__title">{title}</h3>

        <div className="futures-guide-tooltip__counter">
          <span className="futures-guide-tooltip__counter-current">
            {currentStep}
          </span>
          <span className="futures-guide-tooltip__counter-divider">/</span>
          <span className="futures-guide-tooltip__counter-total">
            {totalSteps}
          </span>
        </div>
      </div>

      <p className="futures-guide-tooltip__description">{description}</p>

      <div
        className={`futures-guide-tooltip__actions${
          isFirstStep ? " futures-guide-tooltip__actions--single" : ""
        }`}
      >
        {!isFirstStep && (
          <button
            type="button"
            className="futures-guide-tooltip__button futures-guide-tooltip__button--secondary"
            onClick={onBack}
          >
            <svg
              width="6"
              height="10"
              viewBox="0 0 6 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.16652 10.3338C5.03852 10.3338 4.9105 10.2852 4.81317 10.1872L0.1465 5.52052C-0.0488333 5.32519 -0.0488333 5.0085 0.1465 4.81317L4.81317 0.1465C5.0085 -0.0488333 5.32519 -0.0488333 5.52052 0.1465C5.71586 0.341833 5.71586 0.658523 5.52052 0.853857L1.20721 5.16717L5.52052 9.48048C5.71586 9.67582 5.71586 9.99251 5.52052 10.1878C5.42252 10.2852 5.29452 10.3338 5.16652 10.3338Z"
                fill="#FCFCFD"
              />
            </svg>
            {__("wallet.deposit.back")}
          </button>
        )}

        <button
          type="button"
          className="futures-guide-tooltip__button futures-guide-tooltip__button--primary"
          onClick={onNext}
        >
          {isLastStep ? __("wallet.finish") : __("wallet.continue")}
        </button>
      </div>
    </div>
  );
};

export default FuturesGuideTooltip;
